import React from 'react';
import styled from '@emotion/styled';
import Box from '@mui/material/Box';

import { HubSpotForm } from '~/src/components/HubSpotForm';
import { breakpoints, errorRed, fontWeight } from '~/styles';

import { orangeButtonStyles } from './elements';

interface Props {
  onFormSubmitted: () => void;
}

const SnackbarText = styled.div`
  color: white;
  line-height: 24px;
  letter-spacing: 0.02em;
  text-align: center;
  margin-bottom: 32px;
`;

const SnackbarTitle = styled.div`
  font-size: 20px;
  color: white;
  font-family: Montserrat;
  font-weight: ${fontWeight.bold};
  line-height: 44px;
  letter-spacing: 0.02em;
  text-align: center;
  margin-bottom: 16px;
  ${breakpoints.minTabletLandscape} {
    font-size: 27px;
  }
`;

const formCSS = `
    .hs-form {
      display: flex !important;
      align-items: flex-start;
      gap: 10px;
      justify-content: center;
      @media (max-width: 768px) {
        display: block !important;
        margin: auto;
      }
    }
    .hs-email {
    label[id^='label-email'] {
        display: none;
      }
      margin-bottom: 10px;
      width: unset !important;
      flex: 1;
      @media (max-width: 768px) {
        max-width: unset !important;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 20px;
      }
    }
    .hs-submit{
      flex: 1;
    }
    .hs-input {
      border-radius: 4px;
      background: white;
      border: none;
      height: 50px;
      display: flex;
      font-size: 16px;
    }
    .yi-button {
      ${orangeButtonStyles}
      width: 100% !important;
    }

    .hs-error-msgs {
        list-style: none;
        padding: 0;
        margin-top: 8px;
        color: ${errorRed};
    }
`;

export const FormBody: React.FC<Props> = ({ onFormSubmitted: onSubmitted }) => {
  return (
    <>
      <SnackbarTitle>Essentials of Yin Yoga</SnackbarTitle>
      <SnackbarText>
        Learn how a yin practice can help you release tension, improve flexibility, and recover
        quickly from stress
      </SnackbarText>
      <Box textAlign="center">
        <Box>
          <HubSpotForm
            portalId="1871826"
            formId="76690e43-c284-40be-8d9e-f7b0de4e5685"
            className="hubspot-form"
            submitText="Get my free eBook"
            formCSS={formCSS}
            onFormSubmitted={onSubmitted}
          />
        </Box>
      </Box>
    </>
  );
};
